<ng-container *ngIf="warehouses | async as warehouses">
  <form
    [formGroup]="warehouseForm"
    *ngIf="
      warehouseForm && hasInventoryAddition && warehouses && warehouses.length
    "
  >
    <div class="form-group row">
      <label
        class="col col-form-label text-sm-right col-form-label-sm"
        for="warehouseId"
      >
        <small>{{ 'warehouse-select.label' | translate }}: </small>
      </label>
      <div class="col-auto text-right">
        <select
          tabindex="0"
          class="form-control data-hj-whitelist form-control-sm"
          id="warehouseId"
          name="warehouseId"
          formControlName="warehouseId"
        >
          <option value="">
            {{ 'warehouse-select.select.all' | translate }}
          </option>
          <option [value]="wh.id" *ngFor="let wh of warehouses">
            <ng-container *ngIf="wh.default; else notDefaultWh">{{
              'warehouse-select.select.default' | translate
            }}</ng-container>
            <ng-template #notDefaultWh>{{ wh.name }}</ng-template>
          </option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
